import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import RestAdapter from "discourse/adapters/rest";
export default class ReviewableExplanationAdapter extends RestAdapter {
  constructor() {
    super(...arguments);
    _defineProperty(this, "jsonMode", true);
  }
  pathFor(store, type, id) {
    return `/review/${id}/explain.json`;
  }
}